import { render, staticRenderFns } from "./barras.vue?vue&type=template&id=61a7e6f4&scoped=true&"
import script from "./barras.vue?vue&type=script&lang=js&"
export * from "./barras.vue?vue&type=script&lang=js&"
import style0 from "./barras.vue?vue&type=style&index=0&id=61a7e6f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a7e6f4",
  null
  
)

export default component.exports